/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import Project from './Project'

export default class Projects {
    constructor() {
        this.projects = [];
    }

    addProject(project) {
        var p = new Project(project)
        var index = this.projects.indexOf(p)
        if (index = -1)
            this.projects.push(p);
        else
            this.projects[index] = p;
    }

    clearProjects(){
        this.projects = [];
    }

    get all() {
        return this.projects;
    }
}